import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { HashRouter as Router, Route } from 'react-router-dom'
import Game from './components/Game'
import SwipeHelper from './utils/SwipeHelper'
import GameView from './views/Game'
import HomeView from './views/Home'

const App = () => (
  <Router>
    <Route exact path='/' component={HomeView} />
    <Route exact path='/game/:width/:height/:gameId' component={GameView} />
  </Router>
)

function init() {
  SwipeHelper.init()

  ReactDOM.render(<App />, document.getElementById('root'))
}

init()

export default App
